import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import QuoteForm from "../../../../components/quote/Form/QuoteRequestForm";
import {
  HelpIconInterface,
  Microcopy,
  MicrocopyResource,
} from "../../../../utilities/contentful";
import styled from "@emotion/styled";
import { FormikProps } from "formik";
import { PurchaseDetails } from "../../../../components/purchase/PurchaseData.interface";

interface Props {
  microcopySet: MicrocopyResource[];
  rootTabDetails: {
    coverageDuration: string;
    coverageArea: string;
    tripProtection: string;
    numPeople: string;
  };
  updateBoxText: Function;
  formikProps: FormikProps<PurchaseDetails>;
  setDatesTabText: Function;
  setProtectionTabText: Function;
  setAreaTabText: Function;
  setPeopleTabText: Function;
  startDateTabText: { startDateText: string; datesValid: boolean };
  endDateTabText: { endDateText: string; datesValid: boolean };
  areaTabText: { coverageAreaText: string; coverageValid: boolean };
  protectionTabText: { tripProtectionText: string; protectionValid: boolean };
  peopleTabText: { peopleText: string; peopleValid: boolean };
  helpIcons: HelpIconInterface[];
  onClose: () => void;
}

const style = {
  bgcolor: "background.paper",
  boxShadow: 24,
};

const BoxStyled = styled(Box)`
  position: absolute;
  top: 20px;
  left: 50%;
  max-width: 1024px;
  width: 100%;
  transform: translate(-50%, 0%);
  padding: 0;
`;

const QuoteModal = (props: Props): JSX.Element => {
  const micro = new Microcopy();

  return (
    <BoxStyled sx={style}>
      <Box
        sx={{
          backgroundColor: "#0b213f",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          padding: { xs: "12px 48px 12px 16px", sm: "15px 56px" },
          position: "relative",
        }}
      >
        <Typography
          variant="h6"
          fontSize={{ xs: "15px", sm: "18px" }}
          fontWeight="400"
          textAlign="center"
        >
          {micro.getFromKey("heading.answer-questions", props.microcopySet)}
        </Typography>
        <IconButton
          onClick={props.onClose}
          aria-label="Close"
          sx={{
            position: "absolute",
            right: { xs: "4px", sm: "8px" },
            top: "50%",
            transform: "translateY(-50%)",
            color: "#ffffff",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <QuoteForm
        updateBoxText={props.updateBoxText}
        formikProps={props.formikProps}
        microcopy={props.microcopySet}
        rootTabDetails={props.rootTabDetails}
        setDatesTabText={props.setDatesTabText}
        setProtectionTabText={props.setProtectionTabText}
        setAreaTabText={props.setAreaTabText}
        setPeopleTabText={props.setPeopleTabText}
        startDateTabText={props.startDateTabText}
        endDateTabText={props.endDateTabText}
        areaTabText={props.areaTabText}
        protectionTabText={props.protectionTabText}
        peopleTabText={props.peopleTabText}
        helpIcons={props.helpIcons}
      />
    </BoxStyled>
  );
};

export default QuoteModal;
